import React from 'react';
import { BRAND } from './ui';

export default function LoadingSpinner({ message: customMessage, fullscreen = false }) {
  const text = customMessage || 'Getting things ready…';
  return (
    <>
      <style>{`
        @keyframes coreOwlPulse { 0%, 100% { transform: scale(1); filter: drop-shadow(0 0 0 rgba(205,155,80,0)); } 50% { transform: scale(1.06); filter: drop-shadow(0 0 22px rgba(205,155,80,0.55)); } }
        @keyframes coreRing { to { transform: rotate(360deg); } }
        @keyframes coreDots { 0%, 80%, 100% { opacity: .25; transform: translateY(0); } 40% { opacity: 1; transform: translateY(-5px); } }
      `}</style>
      <div role="status" aria-live="polite" aria-busy="true"
        style={{ minHeight: fullscreen ? '100vh' : '60vh', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 22, padding: 32, background: fullscreen ? BRAND.navy900 : 'transparent', fontFamily: BRAND.font, color: BRAND.ivory }}>
        <div style={{ position: 'relative', width: 110, height: 110, display: 'grid', placeItems: 'center' }}>
          <div aria-hidden style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '2px solid rgba(205,155,80,0.18)', borderTopColor: BRAND.gold, animation: 'coreRing 1.1s linear infinite' }} />
          <img src={BRAND.owl} alt="" style={{ width: 72, height: 72, animation: 'coreOwlPulse 1.6s ease-in-out infinite' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 800, letterSpacing: '0.28em', fontSize: '0.72rem', color: BRAND.goldLight, textTransform: 'uppercase' }}>C.O.R.E. for Schools</span>
          <p style={{ fontFamily: BRAND.serif, fontStyle: 'italic', fontSize: '1.25rem', color: 'rgba(249,240,231,0.85)', margin: 0, textAlign: 'center' }}>{text}</p>
          <div aria-hidden style={{ display: 'flex', gap: 7, marginTop: 4 }}>
            {[0, 1, 2].map(i => <span key={i} style={{ width: 7, height: 7, borderRadius: '50%', background: BRAND.gold, animation: `coreDots 1.2s ease-in-out ${i * 0.15}s infinite` }} />)}
          </div>
        </div>
      </div>
    </>
  );
}
